import { render } from "./concept-arch.vue?vue&type=template&id=58ae9d44"
import script from "./concept-arch.vue?vue&type=script&lang=js"
export * from "./concept-arch.vue?vue&type=script&lang=js"

import "./concept-arch.vue?vue&type=style&index=0&id=58ae9d44&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__